import React from 'react';
import ReactDOM from 'react-dom';
import InfiniteScroll from '../InfiniteScroll';
import SmallPost from '../Models/SmallPost';

class ArchivePage extends React.Component {
  constructor(props) {
    super(props);

    this.state =  {
      pagetype: 'archive',
      endpoint: `post`,
      urlStructure: '%domain%/%year%/%month%/page/%id%/',
      year: window.archive.year || 'newest',
      month: window.archive.month || 'newest',
    };
  }

  getSeoDataArray(post) {
    let seoDataArray = [];

    if (!post) {
      return seoDataArray;
    }
    
    // (TODO:seo) What we do here?
    // const term = post.categories.find(({ id }) => id == window.category.id)
    // if (!term) {
    //   return seoDataArray;
    // }

    // seoDataArray['aller_ga'] = term.seoData.aller_ga ?? {};
    
    return seoDataArray;
  }

  render() {
    return (
      <InfiniteScroll 
        pageId={this.props.pageId} 
        urlStructure={this.state.urlStructure} 
        perPage={12} 
        endpoint={this.state.endpoint} 
        pagetype={this.state.pagetype}
        year={this.state.year} 
        month={this.state.month} 
        getSeoDataArray={this.getSeoDataArray}
        >
        <SmallPost rowCount={3} fitAdsToContent={true}/>
      </InfiniteScroll>
    )
  } 

}
let archivePageElement = document.getElementById('archive');
if (archivePageElement) {
  ReactDOM.render(<ArchivePage pageId={archivePageElement.dataset.pageid}/>, archivePageElement);
}